import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllContentEntityText,
  addText,
  updateText,
  setDefaultText,
  removeText,
} from './thunks';
import { ContentEntityTextState } from './types';

export const name = 'ContentEntityText';

const initialState: ContentEntityTextState = {
  data: [],
  updatingStatus: 'idle',
  status: 'idle',
};
export const getContentEntityTextAsync = createAsyncThunk(
  name + '/getContentEntityText',
  getAllContentEntityText
);

export const addTextAsync = createAsyncThunk(name + '/addText', addText);

export const updateTextAsync = createAsyncThunk(
  name + '/updateText',
  updateText
);

export const setDefaultTextAsync = createAsyncThunk(
  name + '/setDefaultText',
  setDefaultText
);

export const removeTextAsync = createAsyncThunk(
  name + '/removeText',
  removeText
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContentEntityTextAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getContentEntityTextAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getContentEntityTextAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(addTextAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(addTextAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(addTextAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(updateTextAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(updateTextAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })

      .addCase(updateTextAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(setDefaultTextAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(setDefaultTextAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(setDefaultTextAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      })
      .addCase(removeTextAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(removeTextAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(removeTextAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
